import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "m-payment-requests-page__additional" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 18v-6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m9 15 3 3 3-3" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_payment_requests_header_additional = _resolveComponent("payment-requests-header-additional")!
  const _component_payment_requests_balance_widget = _resolveComponent("payment-requests-balance-widget")!
  const _component_bs_page_header = _resolveComponent("bs-page-header")!
  const _component_payment_requests_filters = _resolveComponent("payment-requests-filters")!
  const _component_bs_table_column_manager = _resolveComponent("bs-table-column-manager")!
  const _component_bs_button = _resolveComponent("bs-button")!
  const _component_payment_requests_table_column_number = _resolveComponent("payment-requests-table-column-number")!
  const _component_payment_requests_table_column_date = _resolveComponent("payment-requests-table-column-date")!
  const _component_payment_requests_table_column_cost = _resolveComponent("payment-requests-table-column-cost")!
  const _component_payment_requests_table_column_status = _resolveComponent("payment-requests-table-column-status")!
  const _component_payment_requests_table_column_actions = _resolveComponent("payment-requests-table-column-actions")!
  const _component_bs_table = _resolveComponent("bs-table")!
  const _component_bs_page_table_wrapper = _resolveComponent("bs-page-table-wrapper")!
  const _component_payment_requests_transactions_modal = _resolveComponent("payment-requests-transactions-modal")!
  const _component_payment_requests_top_up_modal = _resolveComponent("payment-requests-top-up-modal")!
  const _component_payment_requests_details_modal = _resolveComponent("payment-requests-details-modal")!
  const _component_payment_requests_pay_modal = _resolveComponent("payment-requests-pay-modal")!
  const _component_bs_page = _resolveComponent("bs-page")!

  return (_openBlock(), _createBlock(_component_bs_page, { class: "m-payment-requests-page" }, {
    default: _withCtx(() => [
      _createVNode(_component_bs_page_header, null, {
        title: _withCtx(() => [
          _createTextVNode(" Бухгалтерия ")
        ]),
        description: _withCtx(() => [
          _createTextVNode(" Управление путевыми листами, ФТЛ заказами и выплатами ")
        ]),
        additional: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_payment_requests_header_additional, {
              loading: _ctx.statisticsState.isLoading,
              total: _ctx.statisticsState.totalCount,
              expenses: _ctx.statisticsState.totalSpendings,
              waiting: _ctx.statisticsState.totalWaiting,
              paid: _ctx.statisticsState.totalAccepted
            }, null, 8, ["loading", "total", "expenses", "waiting", "paid"]),
            _createVNode(_component_payment_requests_balance_widget, {
              loading: _ctx.transactionsState.isLoading,
              balance: _ctx.transactionsState.amount,
              onOpenHistory: _ctx.onOpenTransactions,
              onTopUp: _ctx.onOpenTopUp
            }, null, 8, ["loading", "balance", "onOpenHistory", "onTopUp"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_payment_requests_filters, {
        loading: _ctx.state.isLoading,
        onSubmit: _ctx.onFiltersSubmit,
        onReset: _ctx.onFiltersReset
      }, null, 8, ["loading", "onSubmit", "onReset"]),
      _createVNode(_component_bs_page_table_wrapper, {
        pagination: "",
        loading: _ctx.state.isLoading,
        failed: _ctx.state.isFailed,
        empty: _ctx.state.list.length === 0,
        "total-pages": _ctx.state.pagination.totalPages,
        "total-items": _ctx.state.pagination.totalItems,
        page: _ctx.state.pagination.page,
        "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pagination.page) = $event)),
        limit: _ctx.state.limit,
        "onUpdate:limit": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.limit) = $event)),
        onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadPaymentRequests(_ctx.state.pagination.page))),
        "onChange:page": _cache[4] || (_cache[4] = (page) => _ctx.loadPaymentRequests(page)),
        "onChange:limit": _cache[5] || (_cache[5] = () => _ctx.loadPaymentRequests(_ctx.state.pagination.page))
      }, {
        title: _withCtx(() => [
          _createTextVNode("Все записи")
        ]),
        actions: _withCtx(() => [
          _createVNode(_component_bs_table_column_manager, {
            columns: _ctx.COLUMNS,
            modelValue: _ctx.state.columns,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.columns) = $event))
          }, null, 8, ["columns", "modelValue"]),
          _createVNode(_component_bs_button, { disabled: "" }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" Экспорт ")
            ]),
            _: 1
          })
        ]),
        footer: _withCtx(() => []),
        default: _withCtx(() => [
          _createVNode(_component_bs_table, {
            columns: _ctx.state.columns,
            rows: _ctx.state.list
          }, {
            id: _withCtx(({ row }) => [
              _createVNode(_component_payment_requests_table_column_number, {
                "payment-request": row,
                onClick: _ctx.onOpenDetails
              }, null, 8, ["payment-request", "onClick"])
            ]),
            createdAt: _withCtx(({ row }) => [
              _createVNode(_component_payment_requests_table_column_date, {
                date: row.createdAt
              }, null, 8, ["date"])
            ]),
            totalAmount: _withCtx(({ row }) => [
              _createVNode(_component_payment_requests_table_column_cost, {
                cost: row.totalAmount
              }, null, 8, ["cost"])
            ]),
            statusId: _withCtx(({ row }) => [
              _createVNode(_component_payment_requests_table_column_status, {
                status: row.status
              }, null, 8, ["status"])
            ]),
            actions: _withCtx(({ row }) => [
              _createVNode(_component_payment_requests_table_column_actions, {
                "payment-request": row,
                onPay: _ctx.onOpenPay,
                onDecline: _ctx.onDecline
              }, null, 8, ["payment-request", "onPay", "onDecline"])
            ]),
            _: 1
          }, 8, ["columns", "rows"])
        ]),
        _: 1
      }, 8, ["loading", "failed", "empty", "total-pages", "total-items", "page", "limit"]),
      _createVNode(_component_payment_requests_transactions_modal, {
        loading: _ctx.transactionsState.isLoading,
        failed: _ctx.transactionsState.isFailed,
        balance: _ctx.transactionsState.amount,
        "transaction-history": _ctx.transactionsState.transactionHistory,
        modelValue: _ctx.transactionsState.isOpened,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.transactionsState.isOpened) = $event)),
        onClose: _ctx.onCloseTransactions
      }, null, 8, ["loading", "failed", "balance", "transaction-history", "modelValue", "onClose"]),
      _createVNode(_component_payment_requests_top_up_modal, {
        balance: _ctx.transactionsState.amount,
        modelValue: _ctx.topUpState.isOpened,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.topUpState.isOpened) = $event)),
        onClose: _ctx.onCloseTopUp,
        onDeposited: _ctx.onBalanceDeposited
      }, null, 8, ["balance", "modelValue", "onClose", "onDeposited"]),
      _createVNode(_component_payment_requests_details_modal, {
        "payment-request": _ctx.detailsState.paymentRequest,
        modelValue: _ctx.detailsState.isOpened,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detailsState.isOpened) = $event)),
        onClose: _ctx.onCloseDetails,
        onPay: _ctx.onOpenPay,
        onDecline: _ctx.onDecline
      }, null, 8, ["payment-request", "modelValue", "onClose", "onPay", "onDecline"]),
      _createVNode(_component_payment_requests_pay_modal, {
        "payment-request": _ctx.payState.paymentRequest,
        modelValue: _ctx.payState.isOpened,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payState.isOpened) = $event)),
        onClose: _ctx.onClosePay,
        onPayed: _ctx.onPayed
      }, null, 8, ["payment-request", "modelValue", "onClose", "onPayed"])
    ]),
    _: 1
  }))
}